import {
  JobStatus,
  VirtualCardPushTaskListResponse,
} from 'src/models/virtualCardPushTask.models'
import { ErrorDetailMap } from 'src/utils/error.utils'

export type BulkResponse = {
  bulkVirtualCardUploadId: string
  tasks: VirtualCardPushTaskListResponse[]
}

export type BulkUploadResponse = {
  createdAt?: string
  creditCardId?: string
  id: string
  tasks: VirtualCardPushTaskListResponse[]
  status: JobStatus
  displayName?: string
  invitingUsers?: boolean
  topLevelError?: string
  errorDetailMap?: ErrorDetailMap<string>
}

export interface BulkJobResponse {
  id: string
  displayName?: string
  status: JobStatus
  invitingUsers?: boolean
}

export class BulkJobModel {
  public id: string
  public displayName?: string
  public status: JobStatus
  public invitingUsers?: boolean

  public constructor(data: BulkJobResponse) {
    this.id = data.id
    this.displayName = data.displayName
    this.status = data.status
    this.invitingUsers = data.invitingUsers
  }
}
